import React, { useEffect, useRef, useState } from 'react';
import axiosInstance from '../axiosConfig';

export default function FormChatMasterSearch({ kind, name = '', code = '', disabled, onSelect, onPendingChange, fromDate, toDate }) {
  const label = kind === 'worker' ? 'Worker' : kind === 'ledger' ? 'Ledger' : 'Paid To payee';
  const [query, setQuery] = useState(name);
  const [editing, setEditing] = useState(!code);
  const [options, setOptions] = useState([]);
  const [searching, setSearching] = useState(false);
  const [error, setError] = useState('');
  const [retry, setRetry] = useState(0);
  const pendingCallback = useRef(onPendingChange);
  pendingCallback.current = onPendingChange;
  useEffect(() => { setQuery(name); setEditing(!code); setOptions([]); setError(''); pendingCallback.current(false); }, [name, code]);
  useEffect(() => {
    let current = true;
    const controller = new AbortController();
    const term = query.trim();
    setOptions([]); setError('');
    if (!editing || disabled || (term.length < 2 && !/^\d$/.test(term))) { setSearching(false); return undefined; }
    setSearching(true);
    const timer = setTimeout(async () => {
      try {
        const response = await axiosInstance.get(`/api/form-assistant/masters/${kind}`, { params: { q: term, ...(kind === 'worker' ? { fromDate, toDate } : {}) }, signal: controller.signal });
        if (current) setOptions(response.data.options || []);
      } catch (err) {
        if (current) setError(err.response?.data?.error || 'Search nahi hui. Dobara try karein.');
      } finally { if (current) setSearching(false); }
    }, 300);
    return () => { current = false; clearTimeout(timer); controller.abort(); };
  }, [query, kind, editing, disabled, retry, fromDate, toDate]);
  async function select(option) {
    const updated = await onSelect({ kind, code: option.code });
    if (updated) { setEditing(false); onPendingChange(false); }
  }
  return <div className="afa-chat-master" aria-label={`${label} search in chat`}>
    <div className="afa-chat-master-heading"><strong>{label} master</strong><span>AI</span></div>
    {code && <div className="afa-master-selected">Selected: <strong>{name}</strong> · {code}
      {!editing && <button type="button" className="btn btn-sm btn-link" disabled={disabled} onClick={() => { setEditing(true); onPendingChange(true); }}>Change {label.toLowerCase()}</button>}
    </div>}
    {editing && <>
      <label htmlFor={`afa-search-${kind}`}>{label} ka naam ya code search karein</label>
        <input id={`afa-search-${kind}`} className="form-control" value={query} maxLength={100} disabled={disabled} autoComplete="off" placeholder="Jaise: Mastana" onChange={event => { setQuery(event.target.value); setOptions([]); onPendingChange(true); }} />
      <div className="afa-master-results" aria-live="polite">
        {searching ? <p role="status">Matching {label.toLowerCase()} dhoondh raha hoon…</p>
          : error ? <div role="alert">{error} <button type="button" className="btn btn-sm btn-link" disabled={disabled} onClick={() => setRetry(value => value + 1)}>Retry search</button></div>
            : options.length ? <><ul aria-label={`${label} matches`}>{options.map(option => <li key={`${option.code}:${option.name}`}><button type="button" className="btn btn-outline-primary" disabled={disabled} onClick={() => select(option)}><span>{option.name}</span><small>Code: {option.code} · Select</small></button></li>)}</ul>{options.length >= 12 && <p>More specific naam/code type karein agar ledger list mein nahi hai.</p>}</>
              : <p>{query.trim().length >= 2 || /^\d$/.test(query.trim()) ? 'Match nahi mila. Naam ka chhota hissa ya exact code try karein.' : 'Naam ke kam se kam 2 letters ya Logic code type karein.'}</p>}
      </div>
      {code && <button type="button" className="btn btn-sm btn-link" disabled={disabled} onClick={() => { setQuery(name); setEditing(false); onPendingChange(false); }}>Keep selected {label.toLowerCase()}</button>}
    </>}
  </div>;
}
